export enum CUSTOMER_STATUSES {
  ACTIVE = "ACTIVE",
  UNVERIFIED_DOB = "UNVERIFIED_DOB",
  UNVERIFIED_RS = "UNVERIFIED_RS",
  UNVERIFIED_SECTOR = "UNVERIFIED_SECTOR",
  BLOCKED = "BLOCKED",
  UNDER_DELETION = "UNDER_DELETION",
}
